<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('shopd.otitle')}}</div>
			<!-- <div class="top_right" @click="$router.push('/moneybag')">
				<van-icon name="bars" size="25"/>
			</div> -->
		</div>
		<div class="head-tabs shadow">
		    <a href="#/ordering" class="tab-item active">{{$t('shopd.Ordering')}}</a>
		    <a href="#/ordered" class="tab-item ">{{$t('shopd.done')}}</a>
		    <a href="#/ordersettle" class="tab-item ">{{$t('c3.settlement')}}</a>
		    <a href="#/orderfrezee" class="tab-item ">{{$t('c3.frezee')}}</a>
		</div>
	<!-- 	<div v-if="data" class="empty" >
		    <div class="image"><img src="../images/shop2/empty.png"></div>
		    <a href="#/grap" class="basic_btn">{{$t('shopd.grabbing')}}</a>
		</div> -->
		
		
		<van-empty :description="$t('orders.noOrders')" v-if="!list" />
		<div v-if="!list" class="basic_btn" @click="$router.push('/grap')">{{$t('shopd.grabbing')}}</div>
		
		<div  class="order_list1" v-if="list" v-for="i in list" >
			<div class="records_tabs_box_top">
				{{$t('shopds.onum')}}：{{i.no}}
			</div>
			<img v-if="i.stat==100" src="../images/shop/succ.png" class="records_tabs_box_img">
			<img v-else src="../images/shop/dai.png" class="records_tabs_box_img">
		    <div  class="list_top1">
		        <img :src="i.pic">
		        <div  class="list_text1">
		            <span>{{i.title}}</span>
		            <div>
		                <p >{{i.price}}</p>
		                <p >X1</p>
		            </div>
		        </div>
		    </div>
		    <div  class="list_down1">
		        <div  class="list_down">
					<!-- <div >
					    <span>{{$t('shopds.onum')}}</span>
					    <span>{{i.no}}</span>
					</div> -->
		            <div >
		                <span v-if="i.preuid==0">{{$t('shopds.money')}}</span>
		                <span v-else>{{$t('e.luckyprice')}}</span>
		                <span>{{utils_moneyMark()}} {{i.price}}</span>
		            </div>
					<div v-if="i.stat==50 && i.need<0">
					    <span>{{$t('shopds.needba')}}</span>
					    <span >{{utils_moneyMark()}} {{i.need}}</span>
					</div>
					<!-- <div >
					    <span v-if="i.preuid==0">{{$t('e.rate')}}</span>
					    <span v-else>{{$t('e.luckyrate')}}</span>
					    <span  style="color: rgb(255, 83, 83);">{{(100*i.rate).toFixed(2)}} %</span>
					</div> -->
		            <div >
		                <span v-if="i.preuid==0">{{$t('shopds.income')}}</span>
		                <span v-else>{{$t('e.luckyincome')}}</span>
		                <span  >{{utils_moneyMark()}} {{i.fee}}</span>
		            </div>
					<div >
						  <span>{{$t('e.estimated')}}</span>
						  <span style="color: #ff9a2c;font-size: 20px !important;">{{utils_moneyMark()}} {{(i.price+i.fee).toFixed(0)}}</span>
					</div>
		          <!--  <div >
		                <span>{{$t('shopds.numtask')}}</span>
		                <span>{{i.level}}</span>
		            </div> -->
		            <!-- <div >
		                <span>{{$t('shopds.time')}}</span>
		                <span>{{i.ct}}</span>
		            </div> -->
					<div class="notice" v-if="i.stat==98 || (i.stat==99 && i.pay=='0')">
						<span>
							<van-badge color="#d2d214" content="Frezee" />
						</span>
						<span><van-icon name="warning-o" size="20" color="#d2d214"/></span>
					</div>
					<div class="notice" v-if="i.stat==0">
						<span>
							<van-badge color="#999" content="Undo" />
						</span>
						<span><van-icon name="warning-o" size="20" color="#999"/></span>
					</div>
					<div  v-if="i.stat==100 || i.stat==101">
						<span>
							<van-badge color="#3f9a43" content="Completed" />
						</span>
						<span><van-icon name="passed" size="20" color="#3f9a43"/></span>
					</div>
		        </div>
		        <div v-if="i.stat==50" class="basic_btn" @click.stop="data = i;show = true">{{$t('shopd.completeorder')}}</div>
		    </div>
		</div>
		<div v-if="data" class="payment-all">
		    <div>{{$t('d.amount')}}: {{utils_moneyMark()}}  {{data.price}}</div>
		    <div>
		        <button class="btnsub" @click.stop="show = true">
		            {{$t('shopd.completeorder')}}
		        </button>
		    </div>
		</div>
		<div  v-if="data" class="payment-time">
		    <div>{{$t('d.countdown')}}: 
		        <van-count-down style="display: initial; font-size: 12px; " :auto-start='true' :time="time" format="HH:mm:ss" />
		    </div>
		</div>
		
		
		<van-overlay :show="show" @click="show = false">
		  <div class="wrapper" @click.stop>
		    <div class="pop_box" v-if="data">
		        <div class="order_cards" >
		            <div  class="order_list1" >
						<div class="records_tabs_box_top">
							{{$t('shopds.onum')}}：{{data.no}}
						</div>
						<img v-if="data.stat==100" src="../images/shop/succ.png" class="records_tabs_box_img">
						<img v-else src="../images/shop/dai.png" class="records_tabs_box_img">
		                <div  class="list_top1">
		                    <img :src="data.pic">
		                    <div  class="list_text1">
		                        <span>{{data.title}}</span>
		                        <div>
		                            <p >{{data.price}}</p>
		                            <p >X1</p>
		                        </div>
		                    </div>
		                </div>
		                <div  class="list_down1">
		                    <div  class="list_down">
		            			
		                        <div >
		                            <span v-if="data.preuid==0">{{$t('shopds.money')}}</span>
		                            <span v-else>{{$t('e.luckyprice')}}</span>
		                            <span>{{utils_moneyMark()}} {{data.price}}</span>
		                        </div>
								<div v-if="data.need<0">
								    <span>{{$t('shopds.needba')}}</span>
								    <span>{{utils_moneyMark()}} {{data.need}}</span>
								</div>
								<!-- <div>
								    <span v-if="data.preuid==0">{{$t('e.rate')}}</span>
								    <span v-else>{{$t('e.luckyrate')}}</span>
									<span  style="color: rgb(255, 83, 83);">{{(100*data.rate).toFixed(2)}} %</span>
								</div> -->
		                        <div>
		                            <span v-if="data.preuid==0">{{$t('shopds.income')}}</span>
		                             <span v-else>{{$t('e.luckyincome')}}</span>
									<span style="color: rgb(255, 83, 83);">{{utils_moneyMark()}} {{data.fee}}</span>
		                        </div>
		                        <div >
		                            <span>{{$t('shopds.numtask')}}</span>
		                            <span>{{data.level}}</span>
		                        </div>
								<div >
									  <span>{{$t('e.estimated')}}</span>
									  <span style="color: #ff9a2c;font-size: 20px !important;">
									  {{utils_moneyMark()}} {{(data.price+data.fee).toFixed(0)}}
									  </span>
								</div>
		                        <!-- <div >
		                            <span>{{$t('shopds.time')}}</span>
		                            <span>{{data.ct}}</span>
		                        </div> -->
		                    </div>
		                </div>
		            </div>
		        </div>
		    	<div class="capital_evaluate">
		    		<span>{{$t('shopds.score')}}</span>
		    		<van-rate v-model="star" clearable />
		    	</div>
		        <div class="pop_but"  @click="doorder()">
		            <span><span>{{$t('shopds.deal')}}</span></span>
		        </div>
		        <div class="pop_but second" @click="show = false">
		            <span><span>{{$t('shopd.cancelbtn')}}</span></span>
		        </div>
		    </div>
		  </div>
		</van-overlay>
	</div>
</template>

<script>
	
	import Vue from "vue";
	import {
		Empty
	} from "vant";
    var _that;
	import {
		Dialog,Rate,Overlay,Badge,CountDown,Toast 
	} from 'vant';
	import Fetch from "../../utils/fetch";
	Vue.use(Empty)
	.use(Toast )
	.use(CountDown)
	.use(Rate)
	.use(Badge)
	.use(Overlay);
	export default {
		name: "ordering",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data:null,
				list:null,
				show:false,
				star:0,
				time:0,
				doing:0
			};
		},
		created() {
			this.$parent.footer("ordering");
		},
		mounted() {
			this.start();
			_that = this;
		},
		beforeDestroy() {
		    _that.doing = 0;
		},
		methods: {
			start() {
				Fetch("/user/ordering").then((r) => {
					if(r.data && r.data.length>0){
						this.list = r.data;
						var data = r.data[0];
						if(data.stat==50){
							var currentTimestamp = Date.now()/1000;
							var time = (data.rt-currentTimestamp)*1000;
							if(time<0){
								time=0;
							}
							this.time=time;
							this.data = data;
						}
					}
				});
			},
			doorder(){
				if(this.star<3){
					this.$toast({
						duration:'3000',
						background: '#07c160',
						message: this.$t('shopds.lowscore')
					});
					return false;
				}
				var t = Math.floor(Math.random() * 1000) + 300;
				Toast.loading({
					duration:t,
					forbidClick: true,
					className:'toastc',
					loadingType: 'spinner',
					message: this.$t('d.grap1')
				});
				setTimeout(()=>{
					t = Math.floor(Math.random() * 1000) + 300;
					Toast.loading({
						duration:t,
						forbidClick: true,
						className:'toastc',
						loadingType: 'spinner',
						message: this.$t('d.grap2')
					 });
					setTimeout(()=>{
						t = Math.floor(Math.random() * 1000) + 300;
						Toast.loading({
							duration:t,
							forbidClick: true,
							className:'toastc',
							loadingType: 'spinner',
							message: this.$t('d.grap3')
						});
						setTimeout(()=>{
						  this.dosuborder();
						},t);
					},t);
				},t);
			},
			dosuborder(){
				Fetch("/user/doorder", {
				  id: this.data.id
				}).then(r => {
					this.show = false;
					if(r && r.code==1 && r.data && r.data.islucky){
						this.order=r.data;
						this.star=0;
						this.money = (r.data.money-r.data.price).toFixed(0);
						if(this.order['islucky']){
							this.$toast({
								duration:'5000',
								background: '#07c160',
								message: this.$t('shopd.lorder')
							});
							// this.conf =true;
							// this.show3=true;
						}else{
							// this.show=true;
						}
						this.start();
					}else{
						this.$toast({
							duration:'3000',
							background: '#07c160',
							message: this.$t('shopd.corder')
						});
						this.$router.push('/grap');
					}
					
				}).catch(err=>{
					if(err && err.code==0 && err.data && err.data.need){
						Dialog.confirm({
							title: 'Tips',
							className:"dialogstyle",
							confirmButtonText:this.$t('moneybag.recharge'),
							cancelButtonText:this.$t('shopd.cancelbtn'),
							message: this.$t('shopds.need') + " " +this.utils_moneyMark()+ err.data.need.toFixed(0)
						})
						.then(() => {
						  this.$router.push('/invest');
						})
						.catch(() => {
						});
					}
				})
			},
			receiveRewards(item){
				var index = -1;
				 for(var i=0;i<this.data.list.length;i++){
					if(this.data.list[i].id==item.id){
						index =i;
					}
				}
				
				Fetch("/index/receiveRewards", {
				  id: item.id
				}).then(r => {
					Dialog.alert({
						message: window.vm.$i18n.t('item.getincome')+ r.data.price,
						confirmButtonText: window.vm.$i18n.t('utils.confirm')
					});
					
					this.data.list[index].isling = '0'
					var sysdate = new Date(r.data.sys_date);
					var millSeconds = Math.abs(sysdate) + (1000*60*60*24-1);
					var date1 = new Date(millSeconds);
					var M = (date1.getMonth()+1 < 10 ? '0'+(date1.getMonth()+1) : date1.getMonth()+1) + '-';		
					var sysTime = sysdate.getFullYear() + '-' + M + sysdate.getDate() + ' '+ sysdate.getHours() + ':' + sysdate.getMinutes() + ':' + sysdate.getSeconds();			 
					var countTime = date1.getFullYear() + '-' + M + date1.getDate() + ' '+ date1.getHours() + ':' + date1.getMinutes() + ':' + date1.getSeconds();
					this.data.list[index].sys_time = sysTime;
					this.data.list[index].count_time = countTime;
				}).catch(err=>{
					Dialog.alert({
						message: window.vm.$i18n.t('item.getincomefail'),
						confirmButtonText: window.vm.$i18n.t('utils.confirm')
					});
				})
			}
		},
	};
</script>

<style lang="less" scoped>
	
	.red_top_bg {
		
	}

	.money_box {
		display: flex;
		justify-content: space-around;
		border-radius: 10px;
		padding: 10px;
		margin: 10px;
		color:#36333d;
		background: #FFF;

		.item {
			width: 33.33%;
			text-align: center;
			font-weight: bold;

			.money_num {
				font-size: 18px;
				line-height: 25px;
				white-space: normal;
				word-break: normal;
				text-align: center;
			}

			.info {
				font-size: 12px;
				line-height: 20px;
				font-weight: normal;
				margin-top: 5px;
			}
		}
	}

	.notes_tit {
		line-height: 44px;
		height: 44px;
		font-size: 14px;
		color: #000000;
		padding: 0 14px;
		background: #FAFAFA;
		z-index: 2;
		margin: 10px;
		border-radius: 5px;
	}

	.notes_box {
		width: 100%;
		padding-bottom: 2px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-bottom: 10px;

		.timer {
			padding: 3px 3px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			border-bottom: 1px solid #ececec;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-style: normal;
				padding: 5px;
				border-radius: 5px;
				color: #FFFFFF;
			}

			.ing {
				background: #3775f4;
			}

			.finish {
				font-style: normal;
				background: #07c160;
			}
		}

		.item_div1 {
			display: flex;
			justify-content: space-between;
			padding: 15px 10px;

			p:nth-child(1) {
				width: 100%;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;

			}
		}

		.item_div2 {
			display: flex;
			justify-content: space-between;
			text-align: center;
			margin-bottom: 5px;
			margin-top: 5px;
			div {
				width: 33.33%;

				p {
					padding: 5px 0;
				}
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #FF0000;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_day {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_min {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;

				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}
	}

	.scrollBox {
		width: 96%;
		margin-left: 2%;
	}
	
	.head-tabs {
	    height: 50px;
	    padding: 15px;
	    background: #000;
	    white-space: nowrap;
		border-radius: 10px;
		text-align: center;
		margin: 10px;
		.tab-item {
		    z-index: 0;
		    position: relative;
		    height: 16px;
		    line-height: 16px;
		    font-size: 14px;
		    color: #c8c9cc;
		    transition: all .3s ease;
		}
		.tab-item:after {
		    z-index: -1;
		    content: "";
		    position: absolute;
		    left: 0;
		    right: 0;
		    bottom: 0;
		    height: 4px;
		    border-radius: 2px;
			
		}
		.active {
		    font-size: 1.2em;
		    color: #f1bb0e;
			:after {
			    background: #ff8c46;
			}
		}
		.tab-item.active:after {
		    background: #ff8c46;
		}
		.tab-item+.tab-item {
		    margin-left: 20px;
		}
	}
	.box {
		margin: 3vw;
		border-radius: 2vw;
		overflow: hidden;
	    background-color: rgb(12, 109, 86);
		padding: 0;
		color: #FFF;
		.header1 {
		    display: flex;
		    padding: 0 10px;
		    height: 40px;
		    line-height: 40px;
		    font-size: 14px;
			background: none;
			border-bottom: none;
			color: #FFF;
			.id {
			    font-weight: bold;
				color: #FFF;
			}
			.time {
			    flex: 1;
			    text-align: right;
			    color: #999;
			    font-size: 10px;
				color: #FFF;
			}
		}
		.button {
		    display: block;
		    padding: 0 10px;
		    border-radius: 5px;
		    height: 40px;
		    line-height: 40px;
		    font-size: 16px;
		    color: #FFF;
		    text-align: center;
		    background: linear-gradient(180deg, #36333d, #746b0a);
		    overflow: hidden;
		    cursor: pointer;
		}
		.content {
		    display: flex;
		    padding: 0 10px 10px;
			.left {
			    border-radius: 3vw;
			    width: 90px;
			    height: 90px;
			    padding: 2px;
			    text-align: center;
			    background-color: #75777a;
			    overflow: hidden;
				img {
				    border-radius: 3vw;
				    width: 90px;
				    height: 90px;
				}
			}
			.right {
			    position: relative;
			    flex: 1;
			    padding-left: 10px;
			    line-height: 20px;
				.title {
				    margin-bottom: 10px;
				    height: 40px;
				    font-weight: 500;
				    overflow: hidden;
				}
				 .price,.earnings {
				    color: #aaa;
					 em {
						font-style: normal;
						font-size: 16px;
						font-weight: bold;
						color: #e5ae2f;
					}
				}
			}
			.button {
			    display: block;
			    padding: 0 10px;
			    border-radius: 5px;
			    height: 40px;
			    line-height: 40px;
			    font-size: 18px;
			    color: #202226;
			    text-align: center;
			    background: linear-gradient(180deg, #36333d, #746b0a);
			    overflow: hidden;
			    cursor: pointer;
			}
		}
	}
	.empty{
		text-align: center;
		background-color: #f1bb0e;
		border-radius: 10px;
		padding: 15px;
		margin: 10px;
		img {
			margin: 30px auto;
			height: 180px;
			border-radius: 1.5em;
		}
		.button {
		    display: block;
		    padding: 0 10px;
		    border-radius: 5px;
		    height: 40px;
		    line-height: 40px;
		    font-size: 16px;
		    color: #FFF;
		    text-align: center;
		    background: linear-gradient(180deg, #36333d, #746b0a);
		    overflow: hidden;
		    cursor: pointer;
			display: inline-block;
			padding: 0 20px;
			width: 80%;
		}
	}
	
	.order_list1{
	    background-color: #fff;
	    padding: 10px;
		margin: 10px;
	    border-radius: 10px;
	    box-shadow: 0 4px 4px rgba(0,0,0,.05);
		.list_top1{
		    width: 100%;
		    height: 90%;
		    border-bottom: 1px dashed gray;
		    display: flex;
		    justify-content: space-between;
		    padding: 5px 0;
			background: #f2f2f2;
			padding: 10px;
			border-radius: 5px;
			img{
			    max-width: 100px;
			    max-height: 100px;
			    border-radius: 10px;
			}
			.list_text1{
			    padding-left: 10px;
			    font-weight: bold;
			    display: flex;
			    justify-content: space-between;
			    flex-direction: column;
				> span:first-child {
				    display: block;
				    font-size: 12px;
				    color: #37475a;
				    overflow: hidden;
				    text-overflow: ellipsis;
				    -webkit-line-clamp: 4;
				    display: -webkit-box;
				    -webkit-box-orient: vertical;
					line-height: 1.5em;
				}
				 > div {
				    display: flex;
				    justify-content: space-between;
				    align-items: center;
				    margin: 3% 0;
				    color: #232f3e;
				    font-size: 17px;
				    font-weight: 600;
					> p:last-child {
					    color: #034aff;
					    font-size: 12px;
					}
				}
			}
		}
		.list_down{
		    /* height: 50%; */
		    display: flex;
		    flex-direction: column;
		    justify-content: space-between;
		    font-size: 13px;
			line-height: 32px;
		    padding: 5px 0;
			> div{
			    display: flex;
			    justify-content: space-between;
			    align-items: center;
			    color: #37475a;
			    // height: 20px;
				> span:last-child {
				    color: #232f3e;
				    font-size: 13px;
				}
			}
		}
		.list_down1{
		    height: auto;
		    text-align: end;
			font-size: 16px;
		}
	}
	.basic_btn{
		margin: 1.5em auto;
		height: 38px;
		line-height: 38px;
		font-size: 14px;
	}
	
	.pop_box{
	    width: 90%;
	    max-width: 600px;
	    padding: 5px;
	    position: relative;
	    border-radius: 10px;
	    background-image: linear-gradient(#fca120,#fff);
		.pop_but{
		    width: 96%;
		    margin: 4% 2%;
		    height: 41px;
		    border-radius: 10px;
		    display: flex;
		    align-items: center;
		    justify-content: center;
		    background-color: #232f3e;
		    color: #ffcd00;
			font-size: 1.3em;
		}
		.capital_evaluate{
			width: 100%;
			height: auto;
			padding: 10px;
			font-size: 1.3em;
			>span{
				margin-right: 3%;
			}
		}
		.second{
		    background-color: #d9d9d9;
		    color: #37475a;
		}
	}
	.wrapper {
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    margin-top: 5vh;
	}

	/deep/ .van-overlay{
		position: absolute;
	}
	.basic_wrap{
		position: relative;
		padding-bottom: 100px;
		height: 100vh;
		overflow: scroll;
	}
	
	.payment-all {
		position: fixed;
		justify-content: space-between;
		z-index: 1;
		display: flex;
		bottom: 100px;
		width: 100%;
		height: 60px;
		left: 0;
		transition: all ease 0.5s;
		-webkit-transition: all ease 0.5s;
		-moz-transition: all ease 0.5s;
		-ms-transition: all ease 0.5s;
		background: rgba(255, 255, 255, 0.80);
		box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-webkit-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-moz-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-ms-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-webkit-backdrop-filter: saturate(125%) blur(10px);
		-moz-backdrop-filter: saturate(125%) blur(10px);
		-ms-backdrop-filter: saturate(125%) blur(10px);
		backdrop-filter: saturate(125%) blur(10px);
		line-height: 60px;
	}


	.payment-all > div {
		padding: 0 20px;
		display: table;
	}

	.payment-all > div > button {
		vertical-align: middle;
		display: table-cell;
	}
	.payment-time{
		position: fixed;
		justify-content: space-between;
		z-index: 1;
		display: flex;
		bottom: 60px;
		width: 100%;
		height: 40px;
		line-height: 40px;
		left: 0;
		transition: all ease 0.5s;
		-webkit-transition: all ease 0.5s;
		-moz-transition: all ease 0.5s;
		-ms-transition: all ease 0.5s;
		background: rgba(255, 255, 255, 0.80);
		box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-webkit-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-moz-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-ms-box-shadow: 0px -3px 10px rgba(0, 0, 0, 0.1);
		-webkit-backdrop-filter: saturate(125%) blur(10px);
		-moz-backdrop-filter: saturate(125%) blur(10px);
		-ms-backdrop-filter: saturate(125%) blur(10px);
		backdrop-filter: saturate(125%) blur(10px);
	}
	.payment-time > div {
		padding: 0 20px;
		display: table;
	}
	.btnsub{
		height: 25px;
		line-height: 20px;
		padding: 2px 8px;
		border-radius: 5px;
		margin-left: 10px;
		font-size: 12px;
		box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px;
		background-color: #232f3e;
		color: #ffcd00;
	}
	.dialogstyle{
		top: 60% !important;
	}
	/deep/ .dialogstyle{
		top: 60% !important;
	}
	/deep/ .van-overlay{
		position: fixed !important; 
	}
	
	.records_tabs_box_top{
	    font-size: 12px;
	    color: #9e9e9e;
	    font-weight: 400;
	    text-align: left;
		line-height: 20px;
	}
	.records_tabs_box_img{
	    width: 65px;
	    height: auto;
	    position: absolute;
	    top: 10px;
	    right: 5px;
	}
	.order_list1{
		position: relative;
		background-image: url(data:image/png;base64,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);
		background-size: 100% 100%;
		padding:15px;
	}
</style>
